/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentRegularSchedulesResponseDto } from './search-equipment-regular-schedules-response-dto';


export interface SearchEquipmentRegularSchedulesResponseDtoPagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentRegularSchedulesResponseDto> | null;
}

